import React from "react";
import "./AboutFAQs.css";

const AboutFAQs = () => {
  return (
    <section className="about-faqs" id="about">
      <div className="about-us">
        <section className="about-us-section">
          <h2 className="about-us-title">Who we are?</h2>
          <p className="about-us-text">
            Respected Solution and Investment Limited is a government-approved
            and reliable pawn shop in Lagos that is committed to giving fast,
            safe, and convenient loans against luxury items. We have years of
            experience and a reputation for transparency, dependability, and
            professionalism. We give fair market values and flexible repayment
            terms for an instant cash loan or a gold loan, watch loan, or
            jewelry loan. Our professional team guarantees that your property is
            treated with care and safely stored until you repay your loan in
            full. If you're looking for pawn shops close to you, we are your
            trusted partner, dedicated to helping you realize the cash value of
            your property without selling it.
          </p>
        </section>

        <section className="about-us-section">
          <h2 className="about-us-title">Our mission</h2>
          <p className="about-us-text">
            Our Mission is to make available quick and secure financial services
            in the form of secured pawn loans with the highest integrity and
            professionalism. We want to provide fair loan terms, clear
            processes, and competitive estimates to enable businesses and
            individuals to avail instant money without financial hardships. Our
            mission is to provide a secure financial service in which our
            customers can confidently borrow against their precious belongings
            knowing their goods are well taken care of. With our secure storage,
            convenient repayments, and unparalleled customer experience, we
            desire to be your most reliable pawn shop in proximity, catering to
            the good people of Lagos efficiently and reliably.
          </p>
        </section>
      </div>

      <div className="faq-container">
        <p className="faq-updates">LATEST UPDATES</p>
        <h2 className="faq-title">Frequently Asked Questions (FAQs)</h2>

        <div className="faq-item">
          <h3>How long does the loan approval process take?</h3>
          <p>
            You can receive funds within 20 minutes to 2 hours depending on the
            asset.
          </p>
        </div>

        <div className="faq-item">
          <h3>Is my asset safe with Respected Solution?</h3>
          <p>
            Absolutely! We ensure high-security storage and professional handling of all items.
          </p>
        </div>

        <div className="faq-item">
          <h3>Do you conduct credit checks?</h3>
          <p>
            No credit checks are required. Your asset serves as collateral for
            the loan.
          </p>
        </div>

        <div className="faq-item">
          <h3>Where are you located?</h3>
          <p>
            We are headquartered in Ikota shopping complex, VGC-Ajah, Lagos but
            we have also have agents in Portharcourt, Ughelli (Delta state) and
            Abuja.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutFAQs;
